export default __webpack_public_path__ + "static/media/retake-recorded-audio.59aa0bcd.svg";